export default __webpack_public_path__ + "static/media/maisons_laffitte8.863455f9.jpg";